// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CreateAccountButton_wrapper__28TgJ"};